import { Centrifuge } from "centrifuge";
import { create } from "zustand";

interface CentrifugeStore {
    centrifuge: Centrifuge | null;
    setCentrifuge: (centrifuge: Centrifuge | null) => void;
}

export const useCentrifugeStore = create<CentrifugeStore>()((set) => ({
    centrifuge: null,
    setCentrifuge: (centrifuge) => set({ centrifuge }),
}));
